import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export interface ImpersonatedUser {
  email: string;
  displayName?: string;
}

interface ImpersonationStore {
  impersonatedUser: ImpersonatedUser | null;
  isSuperuser: boolean;
  hasImpersonationError: boolean;
  setImpersonatedUser: (user: ImpersonatedUser) => void;
  clearImpersonatedUser: () => void;
  setSuperuser: (isSuperuser: boolean) => void;
  setImpersonationError: (hasError: boolean) => void;
}

export const useImpersonationStore = create<ImpersonationStore>()(
  persist(
    (set) => ({
      impersonatedUser: null,
      isSuperuser: false,
      hasImpersonationError: false,
      setImpersonatedUser: (user) => set({ impersonatedUser: user }),
      clearImpersonatedUser: () => set({ impersonatedUser: null }),
      setSuperuser: (isSuperuser) => set({ isSuperuser }),
      setImpersonationError: (hasError) => set({ hasImpersonationError: hasError }),
    }),
    {
      name: 'impersonation-storage',
      partialize: (state) => ({
        impersonatedUser: state.impersonatedUser,
        isSuperuser: state.isSuperuser,
      }),
    }
  )
);
